import { SET_AUDIO_INPUT_DEVICE, SET_VIDEO_INPUT_DEVICE } from '../../../react/features/base/devices/actionTypes';
import MiddlewareRegistry from '../../../react/features/base/redux/MiddlewareRegistry';
import { sendKinesisEvent } from './kinesis/actions';
/**
 * Implements the middleware of the feature base/devices.
 *
 * @param {Store} store - Redux store.
 * @returns {Function}
 */
// eslint-disable-next-line no-unused-vars
MiddlewareRegistry.register(store => next => action => {
    switch (action.type) {
        case SET_AUDIO_INPUT_DEVICE: {
            const micDeviceId = action.deviceId;
            store.dispatch(sendKinesisEvent({
                message: 'audio device changed',
                micDeviceId
            }));
            break;
        }
        case SET_VIDEO_INPUT_DEVICE: {
            const cameraDeviceId = action.deviceId;
            store.dispatch(sendKinesisEvent({
                message: 'video device changed',
                cameraDeviceId
            }));
            break;
        }
    }
    return next(action);
});
